import { render, staticRenderFns } from "./appRight.vue?vue&type=template&id=56a464ad&"
import script from "./appRight.vue?vue&type=script&lang=js&"
export * from "./appRight.vue?vue&type=script&lang=js&"
import style0 from "./appRight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports